import { render, staticRenderFns } from "./Breathe.vue?vue&type=template&id=031d6f15&scoped=true&"
import script from "./Breathe.vue?vue&type=script&lang=js&"
export * from "./Breathe.vue?vue&type=script&lang=js&"
import style0 from "./Breathe.vue?vue&type=style&index=0&id=031d6f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d6f15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
